import { useQuery } from "@apollo/client/react"; import { useState, useEffect } from "react";

import { GET_INDICACIONES_BY_ID_EVALUACION } from "../../../../../data/graphQL/queries/GestionAsistencial/getIndicacionesByIdEvaluacion";
import { adaptIndicacionesByIdEvaluacion } from "../../../../../adapters/gestionAsistencial/adaptIndicacionesByIdEvaluacion";

export function useTabIndicacionRows(idEvaluacion) {
  const { data, loading, refetch } = useQuery(
    GET_INDICACIONES_BY_ID_EVALUACION,
    {
      fetchPolicy: "no-cache",
      variables: { idEvaluacion }
    }
  );

  const [rows, setRows] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    if (data) {
      const adaptedRows = adaptIndicacionesByIdEvaluacion(data);
      setRows(adaptedRows);
      setTotalCount(adaptedRows.length);
    }
  }, [data]);

  const deleteRow = (idIndicacion) => {
    setRows((prevRows) => prevRows.filter((row) => row.idIndicacion !== idIndicacion));
    setTotalCount((prevCount) => prevCount - 1);
  };

  return {
    rows,
    totalCount,
    loading,
    refetch,
    deleteRow
  };
}